module.exports = __webpack_public_path__ + "img/header-navigation-below-honda.08e7dcb8.png";